'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productNotFoundComponent = exports.productNotFoundComponent = {
    template: require('./product-not-found.html'),
    controllerAs: 'vm',
    controller: ["common", "$stateParams", "$timeout", "$state", "Analytics", "gettextCatalog", function controller(common, $stateParams, $timeout, $state, Analytics, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.errormessage = $stateParams.message || '404 - Page not found';
        vm.$onInit = init;
        common.navigationMenu.clearActiveMenu();

        function init() {
            common.setTitle(gettextCatalog.getString('Product not found'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/productNotFound', gettextCatalog.getString('Product not found'));

            $timeout(function () {
                $state.go('home');
            }, 5000);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/error/product-not-found.js
// module id = 931
// module chunks = 0